<div id="alert" class="font-main font-bold text-4xl text-navy-90">
  <div class="content h-full flex flex-col justify-center items-center">
    @switch (type$ | async) {
      @case ('success') {
        <app-success-animation width="50px" height="50px" [activateAnimation]="true"></app-success-animation>
      }

      @default {
        <svg-icon class="h-13 w-13" preserveAspectRatio="none" [src]="icon$ | async" [stretch]="true"></svg-icon>
      }
    }
    <span class="message mt-5" translate>{{ text$ | async }}</span>
  </div>
  <div class="footer flex justify-end w-full bg-navy-30">
    <app-new-button [clickOnEnter]="true" (click)="close()">{{ 'core.alerts.okBtn' | translate }}</app-new-button>
  </div>
</div>
